/**
 * Wspolne error codes - frontend (apps/web) i backend (apps/api) wysylaja i
 * rozpoznaja te same kody. Brak driftu code dispatch.
 */

export const ERROR_CODES = {
  // Auth
  AUTH_MISSING: "AUTH_MISSING",
  AUTH_INVALID: "AUTH_INVALID",
  FORBIDDEN: "FORBIDDEN",

  // Validation
  INVALID_BODY: "INVALID_BODY",
  INVALID_VARIANT_TYPE: "INVALID_VARIANT_TYPE",

  // Credits
  INSUFFICIENT_CREDITS: "INSUFFICIENT_CREDITS",
  BALANCE_NOT_FOUND: "BALANCE_NOT_FOUND",
  DEDUCTION_FAILED: "DEDUCTION_FAILED",

  // Free preview / paywall
  FREE_PREVIEW_LIMIT_REACHED: "FREE_PREVIEW_LIMIT_REACHED",
  AUTHENTICATION_REQUIRED: "AUTHENTICATION_REQUIRED",

  // Uprawnienia z planu (migracja na subskrypcje)
  // TOOL_NOT_IN_PLAN vs TOOL_QUOTA_EXCEEDED to dwie różne rozmowy z użytkownikiem:
  // pierwsza to „ten plan tego nie ma", druga „wykorzystałeś limit". Wspólny kod
  // zmusiłby front do zgadywania, który komunikat pokazać.
  TOOL_NOT_IN_PLAN: "TOOL_NOT_IN_PLAN",
  TOOL_QUOTA_EXCEEDED: "TOOL_QUOTA_EXCEEDED",
  OFFER_LIMIT_REACHED: "OFFER_LIMIT_REACHED",
  SEAT_LIMIT_REACHED: "SEAT_LIMIT_REACHED",
  PLAN_UNRESOLVED: "PLAN_UNRESOLVED",
  MEMBER_CANNOT_PURCHASE: "MEMBER_CANNOT_PURCHASE",
  SUBSCRIPTIONS_DISABLED: "SUBSCRIPTIONS_DISABLED",

  // Rate limiting
  RATE_LIMIT: "RATE_LIMIT",
  IP_RATE_LIMIT: "IP_RATE_LIMIT",

  // System
  INTERNAL_ERROR: "INTERNAL_ERROR",
  PERSIST_FAILED: "PERSIST_FAILED",
  NOT_FOUND: "NOT_FOUND",
} as const;

export type ErrorCode = typeof ERROR_CODES[keyof typeof ERROR_CODES];

// User-facing messages PL
export const ERROR_MESSAGES_PL: Record<ErrorCode, string> = {
  AUTH_MISSING: "Musisz się zalogować.",
  AUTH_INVALID: "Sesja wygasła. Zaloguj się ponownie.",
  FORBIDDEN: "Brak uprawnień.",
  INVALID_BODY: "Nieprawidłowe dane formularza.",
  INVALID_VARIANT_TYPE: "Nieprawidłowy typ narzędzia.",
  INSUFFICIENT_CREDITS: "Za mało kredytów. Dokup paczkę.",
  BALANCE_NOT_FOUND: "Nie znaleziono konta kredytowego.",
  DEDUCTION_FAILED: "Nie udało się pobrać kredytów. Spróbuj ponownie.",
  FREE_PREVIEW_LIMIT_REACHED: "Wykorzystałeś darmowe podglądy. Zarejestruj się aby kontynuować.",
  AUTHENTICATION_REQUIRED: "Zaloguj się aby generować więcej zdjęć.",
  TOOL_NOT_IN_PLAN: "To narzędzie nie jest dostępne w Twoim planie.",
  TOOL_QUOTA_EXCEEDED: "Wykorzystałeś limit tego narzędzia w swoim planie.",
  OFFER_LIMIT_REACHED: "Osiągnąłeś limit aktywnych ofert w swoim planie.",
  SEAT_LIMIT_REACHED: "Osiągnąłeś limit agentów w swoim planie.",
  PLAN_UNRESOLVED: "Nie udało się ustalić Twojego planu. Spróbuj ponownie za chwilę.",
  MEMBER_CANNOT_PURCHASE: "Doładowania i plany kupuje właściciel biura.",
  SUBSCRIPTIONS_DISABLED: "Sprzedaż abonamentów jest wstrzymana. Kredyty dokupisz w pakietach.",
  RATE_LIMIT: "Zbyt wiele zapytań. Spróbuj ponownie później.",
  IP_RATE_LIMIT: "Zbyt wiele zapytań z tego IP. Spróbuj później.",
  INTERNAL_ERROR: "Coś poszło nie tak. Spróbuj ponownie.",
  PERSIST_FAILED: "Nie udało się zapisać zmian.",
  NOT_FOUND: "Nie znaleziono.",
};
